import { combineReducers } from 'redux';
import vendors from 'reducers/vendors';
import vendorRequest from 'reducers/vendor-request';
import prescreen from 'reducers/prescreen';
import questionnaire from 'reducers/questionnaire';
import users from 'reducers/users';
import auth from 'reducers/auth';
import utils from 'reducers/utils';
import archive from 'reducers/archive';
import email from 'reducers/email';
import reports from 'reducers/reports';
import externalApi from 'reducers/external-api';

const appReducer = combineReducers({
  vendors,
  vendorRequest,
  prescreen,
  questionnaire,
  users,
  utils,
  auth,
  archive,
  email,
  reports,
  externalApi,
});

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;

export const errorMessage = state => {
  return state.errorMessage;
};

export const isFetching = state => {
  return state.isFetching;
};
